import React from 'react';
import { Select, Form } from 'antd';
import filterConnect from '../../../../../../../common/hoc/filterConnect';

const Option = Select.Option;
// onChange={onChangeViewOrder}
const ServiceTypes = ({ form, serviceTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Вид услуги">
      {getFieldDecorator('serviceTypes')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          name="serviceTypes"
          placeholder="Выберите вид услуги"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {serviceTypes &&
            serviceTypes.map((type, i) => (
              <Option
                key={type.serviceTypeKey}
                value={type.serviceTypeKey}
                label={type.serviceTypeAbbr}
              >
                {type.serviceType}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default filterConnect(ServiceTypes, ['serviceTypes']);
